import { useEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

/**
 * Scrolls the window (and main containers) to the top whenever the user
 * navigates to a new route via <Link>/navigate() or when the hash or query
 * changes. Uses "auto" behavior which is instant on every browser.
 *
 * - Skips restoration on POP (browser back/forward) so native scroll
 *   restoration can do its job.
 */
export default function ScrollToTop() {
  const { pathname, search, hash } = useLocation();
  const navType = useNavigationType(); // 'PUSH' | 'REPLACE' | 'POP'

  useEffect(() => {
    if (navType === 'POP') return;
    // Hash link → let the browser jump to the anchor
    if (hash) return;
    try {
      window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    } catch {
      window.scrollTo(0, 0);
    }
    if (typeof document !== 'undefined') {
      if (document.documentElement) document.documentElement.scrollTop = 0;
      if (document.body) document.body.scrollTop = 0;
    }
  }, [pathname, search, hash, navType]);

  return null;
}
